// https://github.com/remarkjs/react-markdown/blob/main/changelog.md#remove-buggy-html-in-markdown-parser
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

import { enhance } from '../Markdown/enhancers';

export const MarkdownWithHtml = enhance((props) => (
  <ReactMarkdown {...props} rehypePlugins={[rehypeRaw]} />
));

export const MarkdownWithSanitizedHtml = enhance((props) => (
  <ReactMarkdown {...props} rehypePlugins={[rehypeRaw, rehypeSanitize]} />
));

export default MarkdownWithHtml;
